exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-icon{font-size:16px;height:16px;margin:0\n}\n.static-field.v-input{font-size:12px;margin:0 16px 0 -30px;padding-bottom:1px;padding-top:1px\n}\n.static-field.v-input input{padding:0\n}\n.static-field.v-input .v-icon{color:transparent;font-size:20px;margin-right:-15px;margin-top:-15px\n}", ""]);

// exports
